import type { KnowledgeItem } from '@/types';

// 电解铝车间知识库（14 条）
export const aluminumKnowledge: KnowledgeItem[] = [
  {
    id: 'AK001',
    tags: ['电解铝', '工艺', '基础', '反应'],
    question: '电解铝的化学反应是什么？',
    answer: '主反应：2Al₂O₃ + 3C → 4Al + 3CO₂。氧化铝在 950°C 冰晶石熔体中电解，阳极碳块消耗放出 CO₂，阴极聚集铝水。',
  },
  {
    id: 'AK002',
    tags: ['阳极效应', '故障', '电压'],
    question: '什么是阳极效应？怎么熄？',
    answer: '阳极效应是氧化铝浓度过低时阳极上出现气膜（CF₄），槽电压突跳 30-50V。处理：立即下料补浓度 + 降极距 0.5cm + 必要时吹氮气搅拌。',
  },
  {
    id: 'AK003',
    tags: ['分子比', '电解质', '工艺'],
    question: '分子比是什么？多少算正常？',
    answer: '分子比 = NaF / AlF₃ 摩尔比，常规 2.3-2.5。偏碱（>2.5）电导率高过热；偏酸（<2.2）冷槽冻槽。生产中通过加 AlF₃ 或纯碱微调。',
  },
  {
    id: 'AK004',
    tags: ['极距', '电压', '工艺'],
    question: '极距设多少合适？',
    answer: '常用 4.0-5.0 cm。极距大压降大费电；极距小短路风险大易烧阳极。每次换极后要校准。',
  },
  {
    id: 'AK005',
    tags: ['氧化铝浓度', '下料', '工艺'],
    question: '氧化铝浓度应该维持多少？',
    answer: '理想 2.0-3.0 wt%。< 1.5% 阳极效应风险大；> 4% 会沉底结疤。通过点式下料器 4-10 次/h 维持平衡。',
  },
  {
    id: 'AK006',
    tags: ['滚铝', '故障', '磁流体'],
    question: '滚铝怎么处理？',
    answer: '滚铝是磁流体不稳，铝水液面波动 > 5cm。处理：降电流减磁压力 + 抬包抽 0.5t 铝水降液面，必要时停槽检查磁场配置。',
  },
  {
    id: 'AK007',
    tags: ['漏炉', '事故', '安全'],
    question: '槽底漏炉怎么判断？',
    answer: '母线温度突升 > 90°C + 电解质温度反常下降 + 槽底有红色亮斑或火花。**立即停槽切电源 + 撤离人员 + 通知调度**，重大事故必须按预案处置。',
  },
  {
    id: 'AK008',
    tags: ['电流效率', 'KPI', '工艺'],
    question: '电流效率怎么算？',
    answer: '电流效率 η = 实际产铝量 / 理论产铝量。理论：每 1000A·h 出 0.3354 kg 铝（法拉第定律）。现代槽 92-96%，每提升 1% 节电约 200 kWh/t。',
  },
  {
    id: 'AK009',
    tags: ['整流变压器', '电气', '上电'],
    question: '系列电流怎么调？',
    answer: '通过整流变压器的调压档位（带电）+ 饱和电抗器（无级）。先粗调档位再细调电抗，禁止跳档大幅度变动，电流冲击会损坏阳极。',
  },
  {
    id: 'AK010',
    tags: ['HF', '环保', '烟气'],
    question: 'HF 排放为啥重要？',
    answer: 'HF 是氟化物排放，国标 < 3 mg/m³（车间环境）。超标即环保罚款 + 停产。来源是电解质温度高时 NaF/AlF₃ 挥发，控温是关键。',
  },
  {
    id: 'AK011',
    tags: ['抬包', '出铝', '操作'],
    question: '抬包出铝的工艺要点？',
    answer: '真空度 -65~-90 kPa；铝水温度 > 880°C 才好流动；每次出铝 3.5-5t，留底铝 18cm 保持电热平衡。',
  },
  {
    id: 'AK012',
    tags: ['阳极更换', '操作'],
    question: '换极有哪些注意点？',
    answer: '①残极重量 200-280kg 才能换；②天车提升力 ≤ 16t；③换上新极后下放深度按炉膛温度调，避免极距过短；④换极后 4 小时内电压会偏高，正常现象。',
  },
  {
    id: 'AK013',
    tags: ['槽噪声', '工艺', '指标'],
    question: '槽噪声 < 50 mV 重要吗？',
    answer: '噪声反映电解质流动稳定性。> 80 mV 一般是氧化铝快没了或滚铝；> 150 mV 几乎肯定阳极效应在发生。是早期预警指标。',
  },
  {
    id: 'AK014',
    tags: ['安全', '操作'],
    question: '电解铝车间安全注意点？',
    answer: '①槽顶 950°C 高温 + 强磁场，禁止铁器入；②直流大电流，绝缘鞋帽必须穿；③出铝时禁止靠近抬包嘴；④槽底有红斑立即报告，可能漏炉。',
  },
];
